import './style/index.js';

import _Steps from './Steps';

export type { StepItemProps } from './StepItem';
export type { StepsProps } from './Steps';
export * from './type';

export const Steps = _Steps;
export default Steps;
